import api from './api';

export const getRefuel = ({ code, gasStationId }) =>
  api.get(
    `/v1/refuel/validate-request?code=${code}&gasStationId=${gasStationId}`
  );

export const confirmRefuel = payload => api.post('/v1/refuel/confirm', payload);
